<template>
  <v-content>
    <v-dialog v-model="dialogAgenda" width="630">
      <v-card class="p-5">
        <v-card-title class="headline"
          >Disponibilidade no {{ selTipo }}.
        </v-card-title>

        <v-row no-gutters>
          <!---   <v-col cols="12" md="4" lg="4" sm="4">
            <v-checkbox
              v-model="todos"
              color="success"
              label="Disponivel Todos dias"
              @change="marcarTodos"
              false-value="false"
              true-value="true"
            ></v-checkbox></v-col> -->
          <v-col cols="12" md="9" lg="9" sm="9"> </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <div class="vermelha text-left">
              <v-badge color="error" dot tile left></v-badge
              ><span class="ml-2">{{ textoinDisponivel }}</span>
            </div>
            <div class="verde text-left">
              <v-badge dot tile left color="sucesso" class="verde"></v-badge
              ><span class="ml-2">{{ textoDisponivel }}</span>
            </div></v-col
          ></v-row
        >

        <!--<v-row v-for="agenda of agendas" :key="agenda.dia_semana" no-gutters>
          <v-col cols="12" md="4" lg="4" sm="4">
            <v-checkbox
              v-model="agenda.model"
              color="success"
              :label="agenda.dia_semana_texto"
              @change="selDiaSemana($event, agenda.dia_semana, agenda.id)"
              false-value="false"
              true-value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!agenda.vshow"
              :ref="agenda.id"
              :items="horas"
              @change="selHoraInicial($event, agenda.dia_semana)"
              :value="agenda.hora_inicial"
              label="hora inicial"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!agenda.vshow"
              :id="agenda.id"
              :items="horas"
              :value="agenda.hora_final"
              label="hora final"
              @change="selHoraFinal($event, agenda.dia_semana)"
              filled
              dense
            ></v-select> </v-col
        ></v-row>-->

        <v-row no-gutters>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-checkbox
              v-model="dia_1"
              color="success"
              label="Domingo"
              @change="selDiaSemana($event, 1)"
              false-value="false"
              true-value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h1"
              :items="horas"
              @change="selHoraInicial($event, 1)"
              v-model="hora_inicial_1"
              label="hora inicial"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h1"
              :items="horas"
              v-model="hora_final_1"
              label="hora final"
              @change="selHoraFinal($event, 1)"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="2" lg="2" sm="2">
            <v-badge :color="cor_1" tile bottom></v-badge>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-checkbox
              v-model="dia_2"
              color="success"
              @change="selDiaSemana($event, 2)"
              label="Segunda-feira"
              false-value="false"
              true-value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h2"
              :items="horas"
              @change="selHoraInicial($event, 2)"
              v-model="hora_inicial_2"
              label="hora inicial"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h2"
              :items="horas"
              @change="selHoraFinal($event, 2)"
              v-model="hora_final_2"
              label="hora final"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="2" lg="2" sm="2">
            <v-badge :color="cor_2" tile bottom></v-badge>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-checkbox
              v-model="dia_3"
              color="success"
              @change="selDiaSemana($event, 3)"
              label="Terça-feira"
              false-value="false"
              true-value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h3"
              :items="horas"
              @change="selHoraInicial($event, 3)"
              v-model="hora_inicial_3"
              label="hora inicial"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h3"
              :items="horas"
              @change="selHoraFinal($event, 3)"
              v-model="hora_final_3"
              label="hora final"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="2" lg="2" sm="2">
            <v-badge :color="cor_3" tile bottom></v-badge>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-checkbox
              v-model="dia_4"
              color="success"
              @change="selDiaSemana($event, 4)"
              label="Quarta-feira"
              false-value="false"
              true-value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h4"
              :items="horas"
              @change="selHoraInicial($event, 4)"
              v-model="hora_inicial_4"
              label="hora inicial"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h4"
              :items="horas"
              @change="selHoraFinal($event, 4)"
              v-model="hora_final_4"
              label="hora final"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="2" lg="2" sm="2">
            <v-badge :color="cor_4" tile bottom></v-badge>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-checkbox
              v-model="dia_5"
              color="success"
              @change="selDiaSemana($event, 5)"
              label="Quinta-feira"
              false-value="false"
              true-value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h5"
              :items="horas"
              @change="selHoraInicial($event, 5)"
              v-model="hora_inicial_5"
              label="hora inicial"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h5"
              :items="horas"
              @change="selHoraFinal($event, 5)"
              v-model="hora_final_5"
              label="hora final"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="2" lg="2" sm="2">
            <v-badge :color="cor_5" tile bottom></v-badge>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-checkbox
              v-model="dia_6"
              color="success"
              @change="selDiaSemana($event, 6)"
              label="Sexta-feira"
              false-value="false"
              true-value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h6"
              :items="horas"
              @change="selHoraInicial($event, 6)"
              v-model="hora_inicial_6"
              label="hora inicial"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h6"
              :items="horas"
              @change="selHoraFinal($event, 6)"
              v-model="hora_final_6"
              label="hora final"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="2" lg="2" sm="2">
            <v-badge :color="cor_6" tile bottom></v-badge>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-checkbox
              v-model="dia_7"
              color="success"
              @change="selDiaSemana($event, 7)"
              false-value="false"
              true-value="true"
              label="Sábado"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h7"
              :items="horas"
              @change="selHoraInicial($event, 7)"
              v-model="hora_inicial_7"
              label="hora inicial"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3">
            <v-select
              :disabled="!dia_h7"
              :items="horas"
              @change="selHoraFinal($event, 7)"
              v-model="hora_final_7"
              label="hora final"
              filled
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="2" lg="2" sm="2">
            <v-badge :color="cor_7" tile bottom></v-badge>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            class="white--text"
            @click="dialogAgenda = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >PRODUTOS</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>

    <v-card v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn 
          v-show="$can('admin.loja|produtos.create')"
           @click="novo()" color="topEnviados" dark>
            <v-icon>mdi-plus</v-icon>Novo
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemsProdutos"
        :loading="loading_table"
        :items-per-page="25"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        :footerProps="footerProps"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
        <template v-slot:item.status="{ item }">
          <v-switch
            v-show="$can('admin.loja|produtos.edit')"
            dense
            color="green"
            :label="`${checkStatus(item.status)}`"
            @change="mudarStatus(item.id, item.status, 'status')"
            v-model="item.status"
            value
          ></v-switch>
        </template>
        <template v-slot:item.status_cardapio_agenda="{ item }">
          <v-btn
            v-show="$can('admin.loja|produtos.edit') && item.status"
            @click="openAgenda('C', 'Cardapio', item.id)"
          
            icon
            x-small
            :color="item.agenda_C"
          >
            <v-icon>mdi-calendar-clock</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.status_delivery_agenda="{ item }">
          <v-btn
            @click="openAgenda('D', 'Delivery', item.id)"
            v-show="$can('admin.loja|produtos.edit') && item.status_delivery"
            icon
            x-small
            :color="item.agenda_d"
          >
            <v-icon>mdi-calendar-clock</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.status_delivery="{ item }">
          <v-switch
            v-show="$can('admin.loja|produtos.edit')"
            dense
            color="green"
            :label="`${checkStatus(item.status_delivery)}`"
            @change="
              mudarStatus(item.id, item.status_delivery, 'status_delivery')
            "
            v-model="item.status_delivery"
            value
          ></v-switch>
        </template>
        <template v-slot:item.status_entrega_agenda="{ item }">
          <v-btn
            @click="openAgenda('EP', 'Entrega Programada', item.id)"
           
            v-show="$can('admin.loja|produtos.edit') && item.status_entrega"
            icon
            x-small
            :color="item.agenda_ep"
          >
            <v-icon>mdi-calendar-clock</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.status_entrega="{ item }">
          <v-switch
          
            v-show="$can('admin.loja|produtos.edit')"
            dense
            color="green"
            :label="`${checkStatus(item.status_entrega)}`"
            @change="
              mudarStatus(item.id, item.status_entrega, 'status_entrega')
            "
            v-model="item.status_entrega"
            value
          ></v-switch>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small color="btBlue"    v-show="$can('admin.loja|produtos.edit')" class="mr-2" @click="editProduto(item)"
            >edit</v-icon
          >
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogCadastro" scrollable max-width="70%">
      <v-card>
        <v-card-title class>
          
          <span v-if="cadastro">Cadastrar Produtos</span>
          <span v-if="cadastro == false">Editar Produto</span>
          <v-col cols="12" md="4" lg="4">
            <v-checkbox
              v-model="produto.tipo_box"
              label="Box | Cesta | Kit"
              required
              @change="changeTipo()"
              false-value="N"
              true-value="B"
            ></v-checkbox>
          </v-col>
          
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    v-model="produto.descricao_reduzida"
                    label="Nome Produto"
                    filled
                    dense
                    @keypress="tamanhoReduzida"
                    clearable
                    counter="35"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    v-model="produto.descricao"
                    label="Descrição"
                    filled
                    dense
                    @keypress="tamanhoDescricao"
                    clearable
                    required
                    counter="40"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12" lg="12">
                  <v-text-field
                    v-model="produto.info_extra"
                    label="Informações Extras"
                    filled
                    dense
                    @keypress="tamanhoExtra"
                    clearable
                    required
                    counter="160"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xl="2" lg="2" md="2" sm="2" xs="12">
                  <v-text-field
                    filled
                    dense
                    v-mask="'##########'"
                    clearable
                    v-model="produto.codigo"
                    label="Código ERP"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-text-field
                    filled
                    dense
                    v-mask="'#.###'"
                    clearable
                    v-model="produto.qtde_sistema"
                    label="Qtde Sistema"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
                  <v-text-field
                    prepend-inner-icon="monetization_on"
                    filled
                    v-model="produto.preco"
                    v-currency="{
                      currency: null,
                      locale: 'pt-PT',
                      precision: 2,
                    }"
                    dense
                    clearable
                    label="Valor Cardápio"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
                  <v-text-field
                    prepend-inner-icon="monetization_on"
                    filled
                    v-model="produto.preco_delivery"
                    v-currency="{
                      currency: null,
                      locale: 'pt-PT',
                      precision: 2,
                    }"
                    dense
                    clearable
                    label="Valor Delivery"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
                  <v-text-field
                    prepend-inner-icon="monetization_on"
                    filled
                    v-model="produto.preco_entrega"
                    v-currency="{
                      currency: null,
                      locale: 'pt-PT',
                      precision: 2,
                    }"
                    dense
                    clearable
                    label="Valor Ent.Programada"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xl="2" lg="2" md="2" sm="2" xs="12">
                  <v-select
                    v-model="produto.unidade"
                    :items="itemsUnidade"
                    label="Unidade"
                    dense
                    filled
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <div>
                    <v-select
                      v-model="produto.id_categoria"
                      :items="itemsCategoria"
                      label="Categoria"
                      item-text="descricao"
                      item-value="id"
                      class="text-md-left"
                      @change="buscaUltimaOrdem(produto.id_categoria)"
                      clearable
                      dense
                      filled
                      required
                    ></v-select>
                  </div>
                </v-col>
             
                  <v-col cols="12" md="2" lg="2">
                  <v-text-field
                    v-model="produto.ordem"
                    label="Ordem"
                    filled
                    dense
                    clearable
                    required
                  ></v-text-field>
                </v-col>
                </v-row>
                <v-row>

                <v-col cols="12" md="1" lg="1">
                  <v-file-input
                    v-model="imageFile"                    
                    hide-input
                    filled                                   
                    dense                    
                    prepend-icon="mdi-camera-plus"
                    @change="fileSelected"
                    accept="image/*"
                    hide-details
                  ></v-file-input>
                  <input type="hidden" v-model="produto.id" />
                  
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-img
                    height="120"
                    width="120"
                    :src="produto.img"
                    aspect-ratio="1.7"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-col>
                <v-col
                  v-show="box_produto"
                  cols="12"
                  xl="9"
                  lg="9"
                  md="9"
                  sm="12"
                  xs="12"
                >
                  <v-textarea
                    outlined
                    background-color="grey lighten-2"
                    dense
                    label="Lista de Produtos"
                    v-model="produto.box_descricao"
                  ></v-textarea>
                </v-col>

               
              </v-row>
          
              
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Cancelar
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro"
              color="success"
              :loading="gravando"
              class="mr-4"
              @click="gravar()"
            >
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
            <v-btn
              v-if="cadastro == false"
            
              color="success"
              class="mr-4"
               :loading="gravando"
              @click="gravarEdicao()"
            >
              <v-icon small>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
      <v-snackbar
      :timeout="5000"
      :color="error"
      :multi-line="multiline"
      centered  
      :vertical="mode === 'top'"
      v-model="snackbar"
      
    >
      {{ textSnack }}
    </v-snackbar>
    </v-dialog>
    

    <v-snackbar
      :timeout="5000"
      :color="sucesso"
      :multi-line="'multi-line'"
      :vertical="'top'"
      v-model="snackbarSuccess"
      text
    >
      {{ textSucesso }}
    </v-snackbar>
  </v-content>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    source: String,
  },
  data: () => ({
    gravando: false,
    footerProps: { "items-per-page-options": [30, 50, 100] },
    cadastro: true,
    horas: [
      "00:00",
      "01:00",
      "02:00",
      "03:00",
      "04:00",
      "05:00",
      "06:00",
      "07:00",
      "08:00",
      "09:00",
      "10:00",
      "11:00",
      "12:00",
      "13:00",
      "14:00",
      "15:00",
      "16:00",
      "17:00",
      "18:00",
      "19:00",
      "20:00",
      "21:00",
      "22:00",
      "23:00",
    ],
    imagemAntiga:'',
    error: "error",
    tempo: 2000,
    mode: "vertical",
    dialogAgenda: false,
    sucesso: "botao_sucesso",
    snackbarSuccess: false,
    snackbar: false,
    textSucesso: "",
    textSnack: "",
    multiline: true,
    produtos_box: [],
    box: {
      id_produto: "",
      id_produto_box: "",
      unidade: "",
      qtde_descricao: "",
      qtde_sistema: "",
    },
    singleLine: true,
    produto: {
      id: "",
      descricao: "",
      codigo: "",
      preco: "",

      id_categoria: "",
      descricao_reduzida: "",
      qtde_sistema: "",
      unidade: "UN",
      img: "",
      tipo_box: "N",
    },
    listaProduto: [],
    itemsCategoria: [],
    itemsUnidade: ["UN"],

    filtroProduto: "Produtos ",
    sv: false,
    dialogCadastro: false,
    dialogCadastroEditar: false,
    itensPorPagina: 25,
    itemsProdutos: [],
    itemsProdutosSgt: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    selTipo: "",
    dialogVinc: false,
    imageFile: [],
    headers: [
      {
        text: "Código",
        align: "right",
        value: "id",
        width: "5%",
      },
      {
        text: "Código ERP",
        align: "right",
        value: "codigo",
        width: "7%",
      },
      {
        text: "Produto",
        value: "descricao_reduzida",
        sortable: true,
        align: "left",
        width: "150px",
      },
      {
        text: "Ordem",
        value: "ordem",
        sortable: true,
        align: "left",
        width: "150px",
      },

      {
        text: "Categoria",
        value: "categoria",
        sortable: true,
        align: "left",
      },
      {
        text: "UN",
        value: "unidade",
        align: "center",
        width: "50px",
      },
      /* {
        text: "Qtde. Sistema",
        value: "qtde_sistema",
        align: "right",
      },*/

      {
        text: "Valor Cardápio",
        value: "preco",
        align: "right",
      },
      {
        text: "Valor Delivery",
        value: "preco_delivery",
        align: "right",
        width: "120px",
      },
      {
        text: "Valor Entrega Prog.",
        value: "preco_entrega",
        align: "right",
        width: "150px",
      },
      ,
      {
        text: "",
        value: "status_cardapio_agenda",
        align: "left",
        width: "10px",
      },
      /* {
        text: "Imagem",
        value: "img",
        align: "left",
      }*/ {
        text: "Cardápio",
        value: "status",
        align: "left",
        width: "120px",
      },
     
      {
        text: "",
        value: "status_delivery_agenda",
        align: "left",
        width: "10px",
      },
      {
        text: "Delivery",
        value: "status_delivery",
        align: "left",
        width: "120px",
      },
      {
        text: "",
        value: "status_entrega_agenda",
        align: "left",
        width: "10px",
      },
      {
        text: "Ent.Programada",
        value: "status_entrega",
        align: "left",
        width: "130px",
      },
      { text: "Editar", value: "action", sortable: false },
    ],
    hora_inicial_1: "00:00",
    hora_final_1: "23:00",
    hora_inicial_2: "00:00",
    hora_final_2: "23:00",
    hora_inicial_3: "00:00",
    hora_final_3: "23:00",
    hora_inicial_4: "00:00",
    hora_final_4: "23:00",
    hora_inicial_5: "00:00",
    hora_final_5: "23:00",
    hora_inicial_6: "00:00",
    hora_final_6: "23:00",
    hora_inicial_7: "00:00",
    hora_final_7: "23:00",

    dia_1: "",
    dia_2: "",
    dia_3: "",
    dia_4: "",
    dia_5: "",
    dia_6: "",
    dia_7: "",

    todos: "true",

    dia_h1: false,
    dia_h2: false,
    dia_h3: false,
    dia_h4: false,
    dia_h5: false,
    dia_h6: false,
    dia_h7: false,
    tipo_ent: "",
    sel_produto_agenda: "",
    agendas: [],

    agenda_produto: {
      id_produto: "",
      dia_semana: "",
      hora_inicial: "",
      hora_final: "",
      tipo: "",
    },
    box_produto: false,

    box_categoria: true,
    textoDisponivel: "Disponível para vendas.",
    textoinDisponivel: "Indisponível para vendas.",
    corLabel: "verde",
    showLabel: false,

    cor_1: "error",
    cor_2: "error",
    cor_3: "error",
    cor_4: "error",
    cor_5: "error",
    cor_6: "error",
    cor_7: "error",
  }),

  mounted() {
    //this.buscaProdutos();
    this.buscaProdutos();
    this.produtos();
    this.categorias();
    this.produto.unidade = "UN";
    // this.retornaDiasHorario();
  },
  watch: {
    "produto.preco"(val) {
      if (this.cadastro) {
        this.produto.preco_delivery = val;
        this.produto.preco_entrega = val;
      }
    },
  },
  methods: {
    buscaUltimaOrdem(val){
      /*alert(val)*/
      const produtosFiltrados = this.itemsProdutos.filter(produto => produto.id_categoria === val);

// Encontrar o maior valor de ordem entre os produtos filtrados
      let maxOrdem = Math.max(...produtosFiltrados.map(produto => produto.ordem));
      if(maxOrdem =="-Infinity"){
        maxOrdem = 0;
      }
      this.produto.ordem = maxOrdem+1

    },
    addProduto() {
      alert(this.box.id_produto);
    },
    changeTipo() {
      console.log(this.produto.tipo_box);
      if (this.produto.tipo_box == "B") {
        this.box_produto = true;
        this.box_categoria = false;
      } else {
        this.box_produto = false;
        this.box_categoria = true;
      }
    },
    retornaDiasHorario() {
      this.agendas = [
        {
          id: 10,
          id_produto: "1",
          model: "false",
          show: "dia_h3",
          vshow: false,
          dia_semana: "3",
          dia_semana_texto: "Terça-feira",
          hora_inicial: "00:00",
          hora_final: "23:00",
          tipo: "D",
        },
        {
          id_produto: "1",
          model: "true",
          show: "dia_h4",
          vshow: true,
          dia_semana: "4",
          id: 8,
          dia_semana_texto: "Quarta-feira",
          hora_inicial: "01:00",
          hora_final: "09:00",
          tipo: "D",
        },
        {
          id_produto: "1",
          model: "true",
          show: "dia_h5",
          vshow: true,
          id: 9,
          dia_semana: "5",
          dia_semana_texto: "Quinta-feira",
          hora_inicial: "09:00",
          hora_final: "19:00",
          tipo: "D",
        },
      ];
    },
    marcarTodos(val) {
      if (val == "true") {
        this.dia_1 = "false";
        this.dia_h1 = false;
        this.dia_2 = "false";
        this.dia_h2 = false;
        this.dia_3 = "false";
        this.dia_h3 = false;
        this.dia_4 = "false";
        this.dia_h4 = false;
        this.dia_5 = "false";
        this.dia_h5 = false;
        this.dia_6 = "false";
        this.dia_h6 = false;
        this.dia_7 = "false";
        this.dia_h7 = false;

        this.showLabel = false;
        this.deletaDiaHorarioTodos(this.agenda_produto);
      } else {
        this.showLabel = true;
      }

      //console.log(this.agenda_produto.id_produto, this.agenda_produto.tipo);

      //atualiza zerar todos horarios daquele produto e daquele ptipo
    },
    openAgenda(tipo, tipoLabel, id_produto) {
      this.dialogAgenda = true;
      this.tipo_ent = tipo;
      this.selTipo = tipoLabel;
      this.sel_produto_agenda = id_produto;
      this.agenda_produto.id_produto = id_produto;
      this.agenda_produto.tipo = this.tipo_ent;

      this.getAgenda(id_produto, tipo);
    },
    tamanhoReduzida(ev) {
      if (ev.target.value.length === 35) {
        event.preventDefault();
        return;
      }
    },
    tamanhoDescricao(ev) {
      if (ev.target.value.length === 40) {
        event.preventDefault();
        return;
      }
    },
    tamanhoExtra(ev) {
      if (ev.target.value.length === 160) {
        event.preventDefault();
        return;
      }
    },
    selDiaSemana(check, val, id) {
      eval("this.dia_h" + val + "=" + check);
      //eval("this.$refs." + id + ".");
      this.agenda_produto.id_produto = this.sel_produto_agenda;
      this.agenda_produto.dia_semana = val;
      this.agenda_produto.tipo = this.tipo_ent;
      this.agenda_produto.hora_inicial = eval("this.hora_inicial_" + val);
      this.agenda_produto.hora_final = eval("this.hora_final_" + val);

      if (check == "true") {
        // this.showLabel = true;
        eval("this.cor_" + val + "='botao_sucesso'");
        for (let i = 1; i < 8; i++) {
          if (eval("this.dia_" + i) == "false") {
            console.log(i + "" + eval("this.dia_" + i));
            eval("this.cor_" + i + "= 'error'");
          }

          //   console.log(i + "" + eval("this.dia_" + i));
          //  eval("this.cor_" + i + "= 'error'");
          //}
        }

        this.atualizaDiaHorario(this.agenda_produto);
      }
      if (check == "false") {
        this.showLabel = false;
        eval("this.cor_" + val + "='error'");
        this.deletaDiaHorario(this.agenda_produto);
        if (
          this.dia_1 == "false" &&
          this.dia_2 == "false" &&
          this.dia_3 == "false" &&
          this.dia_4 == "false" &&
          this.dia_5 == "false" &&
          this.dia_6 == "false" &&
          this.dia_7 == "false"
        ) {
          this.cor_1 = "botao_sucesso";
          this.cor_2 = "botao_sucesso";
          this.cor_3 = "botao_sucesso";
          this.cor_4 = "botao_sucesso";
          this.cor_5 = "botao_sucesso";
          this.cor_6 = "botao_sucesso";
          this.cor_7 = "botao_sucesso";
        }
      }
    },
    fileSelected(evt) {
      this.produto.img = URL.createObjectURL(evt);
    },
    selHoraInicial(val, dia) {
      this.agenda_produto.dia_semana = dia;
      this.agenda_produto.hora_inicial = val;
      this.agenda_produto.hora_final = "";
      this.atualizaDiaHorario(this.agenda_produto);
    },
    selHoraFinal(val, dia) {
      this.agenda_produto.dia_semana = dia;
      this.agenda_produto.hora_final = val;
      this.agenda_produto.hora_inicial = "";
      this.atualizaDiaHorario(this.agenda_produto);
    },
    zeraInformacoes() {
      this.hora_inicial_1 = "00:00";
      this.hora_final_1 = "23:00";
      this.hora_inicial_2 = "00:00";
      this.hora_final_2 = "23:00";
      this.hora_inicial_3 = "00:00";
      this.hora_final_3 = "23:00";
      this.hora_inicial_4 = "00:00";
      this.hora_final_4 = "23:00";
      this.hora_inicial_5 = "00:00";
      this.hora_final_5 = "23:00";
      this.hora_inicial_6 = "00:00";
      this.hora_final_6 = "23:00";
      this.hora_inicial_7 = "00:00";
      this.hora_final_7 = "23:00";

      this.dia_1 = "false";
      this.dia_2 = "false";
      this.dia_3 = "false";
      this.dia_4 = "false";
      this.dia_5 = "false";
      this.dia_6 = "false";
      this.dia_7 = "false";

      this.todos = "true";

      this.dia_h1 = false;
      this.dia_h2 = false;
      this.dia_h3 = false;
      this.dia_h4 = false;
      this.dia_h5 = false;
      this.dia_h6 = false;
      this.dia_h7 = false;
    },

    getAgenda(id_produto, tipo) {
      this.zeraInformacoes();

      this.cor_1 = "error";
      this.cor_2 = "error";
      this.cor_3 = "error";
      this.cor_4 = "error";
      this.cor_5 = "error";
      this.cor_6 = "error";
      this.cor_7 = "error";
      axios
        .get(`/adm/produto/agenda/` + id_produto + `/` + tipo)
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            //this.buscaProdutos();
            var json = response.data;
            this.serializa(json);
          }
        });
    },
    serializa(json) {
      console.log("json" + json.length);
      if (json.length == 0) {
        //this.showLabel = true;
        //this.todos = false;
        this.cor_1 = "botao_sucesso";
        this.cor_2 = "botao_sucesso";
        this.cor_3 = "botao_sucesso";
        this.cor_4 = "botao_sucesso";
        this.cor_5 = "botao_sucesso";
        this.cor_6 = "botao_sucesso";
        this.cor_7 = "botao_sucesso";
        return false;
      }

      for (var prop in json) {
        eval("this.dia_h" + json[prop].dia_semana + "=true");
        eval("this.dia_" + json[prop].dia_semana + "='true'");
        eval("this.cor_" + json[prop].dia_semana + "='botao_sucesso'");

        eval(
          "this.hora_inicial_" +
            json[prop].dia_semana +
            "='" +
            json[prop].hora_inicial +
            "'"
        );
        eval(
          "this.hora_final_" +
            json[prop].dia_semana +
            "='" +
            json[prop].hora_final +
            "'"
        );
        //console.log("obj." + prop + " = " + json[prop].dia_semana );
      }
    },
    atualizaDiaHorario(agenda) {
      axios.post(`/adm/produto/agenda`, agenda).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.snackbarSuccess = true;
          this.textSucesso = "Disponibilidade alterada!";
          //this.buscaProdutos();
        }
      });
    },

    deletaDiaHorario(agenda) {
      axios.post(`/adm/produto/agenda/deleta`, agenda).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.snackbarSuccess = true;
          this.textSucesso = "Disponibilidade excluida!";
          //this.buscaProdutos();
        }
      });
    },
    deletaDiaHorarioTodos(agenda) {
      axios.post(`/adm/produto/agenda/deleta_all`, agenda).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.snackbarSuccess = true;
          this.textSucesso = "Disponibilidade excluida!";
          //this.buscaProdutos();
        }
      });
    },
    mudarStatus(id, status, tipo) {
      axios
        .post(`/adm/produto/status`, { id: id, status: status, tipo: tipo })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Status alterado!";
            this.buscaProdutos();
          }
        });
    },
    checkStatus(valor) {
      if (valor) {
        return "ativo";
      } else {
        return "suspenso";
      }
    },
    novo() {
      this.cadastro = true;
      this.dialogCadastro = true;
      this.box_produto = false;
      this.box_categoria = true;
      this.produto.tipo_box = "N";
      this.produto.id = "";
      this.produto.descricao = "";
      this.produto.codigo = "";
      this.produto.preco = "";
      this.produto.preco_delivery = "";
      this.produto.preco_entrega = "";
      this.produto.id_categoria = "";
      this.produto.descricao_reduzida = "";
      this.produto.qtde_sistema = "";
      this.produto.unidade = "UN";
      this.produto.img = "https://placehold.co/96";

      this.imageFile = null;
      this.produto.info_extra = "";
      this.produto.box_descricao = "";

      const produtosFiltrados = this.itemsProdutos.filter(produto => produto.id_categoria === 13);

// Encontrar o maior valor de ordem entre os produtos filtrados
      const maxOrdem = Math.max(...produtosFiltrados.map(produto => produto.ordem));

    },

    editProduto(item) {
      this.cadastro = false;
      this.dialogCadastro = true;
      //this.itemEdit = item.id;

      this.produto.id = item.id;
      this.produto.descricao = item.descricao;
      this.produto.codigo = item.codigo;
      this.produto.preco = item.preco;
      this.produto.preco_delivery = item.preco_delivery;
      this.produto.preco_entrega = item.preco_entrega;
      this.produto.id_categoria = item.id_categoria;
      this.produto.descricao_reduzida = item.descricao_reduzida;
      this.produto.qtde_sistema = item.qtde_sistema;
      this.produto.unidade = item.unidade;
      this.produto.ordem = item.ordem;
      if(item.ordem==0){
        this.produto.ordem = 1
      }
      this.produto.info_extra = item.info_extra;
      this.imageFile = null
      if (item.img_url !== null) {
        this.imagemAntiga= item.img_url;
        this.produto.img = item.img_url;
      } else {
        this.produto.img =
          "https://via.placeholder.com/110x110.png?text=Sem imagem";
      }
      // this.buscaImgProduto(this.produto.id);
    },
    buscaImgProduto(id) {
      axios.get(`/produto/img/` + id).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          if (response.data !== "") {
            this.produto.img = response.data;
          } else {
            this.produto.img =
              "https://via.placeholder.com/110x110.png?text=Sem imagem";
          }
        }
      });
    },
    categorias() {
      axios.get(`/categoria/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.itemsCategoria = response.data;
        }
      });
    },
    async gravarEdicao() {
      this.gravando=true;
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      //console.log(this.file);

      var formData = new FormData();

      var imagefile = document.querySelector("#avatar");
      //formData.append("image", imagefile.files[0]);
      formData.append("image", this.imageFile);
      formData.append("produto", JSON.stringify(this.produto));
      // formData.append("file", document.getElementById("avatar"));

      await axios
        .post(
          `/produto/editar`,

          formData,
          config
        )
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.itemEdit = "";
            this.selProduto = "";
            this.snackbarSuccess = true;
            this.textSucesso = "Produto alterado com sucesso!";
            this.dialogCadastro = false;
            this.buscaProdutos();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
            this.produto.img = this.imagemAntiga
        });

      
        this.imageFile = null;
        this.gravando=false;
    },
    async gravar() {
      this.gravando=true;

      let config = { headers: { "Content-Type": "multipart/form-data" } };
      //console.log(this.file);
      var formData = new FormData();
      var imagefile = document.querySelector("#avatar");
      //formData.append("image", imagefile.files[0]);
      formData.append("image", this.imageFile);
      formData.append("produto", JSON.stringify(this.produto));
      // formData.append("file", document.getElementById("avatar"));

     await axios
        .post(
          `/produto`,

          formData,
          config
        )
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.itemEdit = "";
            this.selProduto = "";
            this.snackbarSuccess = true;
            this.dialogCadastro = false;
            this.textSucesso = "Produto incluido com sucesso!";
            this.buscaProdutos();
          }
        })
       .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
        this.imageFile = null;
        this.gravando=false;
    },
    checkHours(val) {
      alert(val);
    },
    produtos() {
      axios.get(`/produto/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.listaProduto = response.data;
        }
      });
    },
    buscaProdutos() {
      this.loading_table = true;
      axios.get(`/adm/produto/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          //this.loading_filtrar = false;
          this.itemsProdutos = response.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 5px !important;
  margin-bottom: 5px !important;
  margin-top: 16px;
  padding-top: 4px;
}
.v-data-table td {
  font-size: 0.685rem !important;
}
.v-input__slot {
  margin-bottom: 0px !important;
}
.v-messages {
  min-height: 0px !important;
}
.v-select__selection {
  width: 100%;
  justify-content: left !important;
}
.verde {
  color: green;
  font-size: 12px;
}
.vermelha {
  color: red;
  font-size: 12px;
}
.v-dialog__content {
  align-items: center;
  text-align: center !important;
}
</style>
